// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3aqo4","title":"styles_title__anMEO"};